module.exports = __webpack_public_path__ + "static/media/Intersection.76ac98d6.jpg";